
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6aZ5T", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb8521585dee6236$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $iK7QL = parcelRequire("iK7QL");

var $9EUfN = parcelRequire("9EUfN");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");


var $fDXXi = parcelRequire("fDXXi");


var $dTk3A = parcelRequire("dTk3A");


var $81aSu = parcelRequire("81aSu");


var $2qY37 = parcelRequire("2qY37");


var $bUp2E = parcelRequire("bUp2E");


var $aCzn4 = parcelRequire("aCzn4");


var $fVnHQ = parcelRequire("fVnHQ");


var $caPHA = parcelRequire("caPHA");




class $2b2ce0b0062a7857$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $2b2ce0b0062a7857$export$2e2bcd8739ae039 = $2b2ce0b0062a7857$export$e926676385687eaf;






const $8c4f830abcac73ad$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7fS2v")));



var $2q1np = parcelRequire("2q1np");

class $5b8c19cec0dfc921$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $81aSu.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $2qY37.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2b2ce0b0062a7857$export$e926676385687eaf), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $dTk3A.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, $dh538.fg)('enable_appropriate_reading_order_in_profile_card') && this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.showTimer = 0;
        this.hideTimer = 0;
        this.openedByHover = false;
        this.openTime = 0;
        this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $bUp2E.fireEvent)(this.props.createAnalyticsEvent, payload);
        };
        this.fireAnalyticsNext = (eventKey, ...attributes)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.fireEvent) this.props.fireEvent(eventKey, ...attributes);
        };
        this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $caPHA.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        };
        this.fireAnalyticsWithDurationNext = (eventKey, generator)=>{
            const duration = (0, $caPHA.getPageTime)() - this.openTime;
            const attributes = generator(duration);
            this.fireAnalyticsNext(eventKey, attributes);
        };
        this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        };
        this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $caPHA.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        };
        this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $aCzn4.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                    method: 'click',
                    ...(0, $bUp2E.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId
                });
            }
        };
        this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                    method: 'hover',
                    ...(0, $bUp2E.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId
                });
            }
            this.showProfilecard((0, $fVnHQ.DELAY_MS_SHOW));
        };
        this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $fVnHQ.DELAY_MS_HIDE));
        };
        this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalyticsNext('ui.teamProfileCard.triggered', {
                    method: 'click',
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId,
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
            }
        };
        this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        };
        this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $fVnHQ.DELAY_MS_HIDE));
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
        this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        };
        this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        };
        this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        };
        this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const fireAnalyticsNext = (eventKey, ...attributes)=>{
                    this.fireAnalyticsNext(eventKey, ...attributes);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent, fireAnalyticsNext),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.onErrorBoundary = ()=>{
            this.fireAnalyticsNext('ui.teamProfileCard.rendered.errorBoundary', {
                ...(0, $bUp2E.PACKAGE_META_DATA),
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                duration: 0
            });
            this.setState({
                renderError: true
            });
        };
        this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                analyticsNext: this.fireAnalyticsWithDurationNext,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $2q1np.default), {
                        analytics: this.fireAnalyticsWithDuration,
                        analyticsNext: this.fireAnalyticsWithDurationNext
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8c4f830abcac73ad$export$82a49d896f41ca78), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        };
        this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iK7QL.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $9EUfN.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        };
        this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $2qY37.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $l998X.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
$5b8c19cec0dfc921$export$f811dc569217c959.defaultProps = {
    actions: [],
    trigger: 'hover',
    position: 'bottom-start',
    triggerLinkType: 'link',
    shouldRenderToParent: true
};
const $5b8c19cec0dfc921$var$TeamProfileCardTrigger = (props)=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    if ((0, $dh538.fg)('people-teams-deprecate-profilecard-teams')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($5b8c19cec0dfc921$export$f811dc569217c959, {
        ...props,
        fireEvent: fireEvent
    });
};
var /**
 * @deprecated This component is deprecated and provides no functionality.
 * It now simply renders its children without any profile card behavior.
 * Please use `@atlassian/team-profilecard` instead for team profile card functionality.
 */ $5b8c19cec0dfc921$export$2e2bcd8739ae039 = (0, $gmMgo.default)($5b8c19cec0dfc921$var$TeamProfileCardTrigger);


var $bb8521585dee6236$export$2e2bcd8739ae039 = (0, $5b8c19cec0dfc921$export$2e2bcd8739ae039);

});

parcelRegister("7fS2v", function(module, exports) {

let $5483da36ed8fd628$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5483da36ed8fd628$var$load("eY3St"),
    $5483da36ed8fd628$var$load("bkd4T"),
    $5483da36ed8fd628$var$load("6wr18"),
    $5483da36ed8fd628$var$load("ffEVr"),
    $5483da36ed8fd628$var$load("jnkIk")
]).then(()=>parcelRequire('3PwS1'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("2q1np", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e9a613b6d3c33c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9hlns = parcelRequire("9hlns");


var $by9Aj = parcelRequire("by9Aj");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");

var $08e9a613b6d3c33c$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics, analyticsNext: analyticsNext } = props;
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('ptc-enable-profile-card-analytics-refactor')) analyticsNext('ui.teamProfileCard.rendered.spinner', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            }));
        else analytics((duration)=>(0, $bUp2E.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics,
        analyticsNext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $by9Aj.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.CardContent), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
                })
            })
        ]
    });
};

});

parcelRegister("by9Aj", function(module, exports) {
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $42omo = parcelRequire("42omo");





var $dh538 = parcelRequire("dh538");




const $51d6e29b89f36ec6$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13li12b0 _qrwq12b0 _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug",
    imageNext: "_4t3i1osq _5ral1dfr",
    grayoutImage: "_kdam7g3v"
};
const $51d6e29b89f36ec6$export$a65e282337ff0f53 = ({ src: src, alt: alt = '', isDisabled: isDisabled })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const imgRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: containerRef,
        xcss: $51d6e29b89f36ec6$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: (0, $1Whri.cx)((0, $dh538.fg)('cover-header-image-team-profilecard') ? $51d6e29b89f36ec6$var$styles.imageNext : $51d6e29b89f36ec6$var$styles.image, isDisabled && $51d6e29b89f36ec6$var$styles.grayoutImage)
        })
    });
};


const $45954f322eeb538a$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rko12b0 _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
    grayoutImage: "_kdam7g3v"
};
const $45954f322eeb538a$export$a443be8291b92497 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardtriggerwrapper)
    });
const $45954f322eeb538a$export$6aa22a823032b784 = ({ testId: testId, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    });
const $45954f322eeb538a$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label, isDisabled: isDisabled })=>isLoading || !image ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardheader, isDisabled && $45954f322eeb538a$var$styles.grayoutImage),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $51d6e29b89f36ec6$export$a65e282337ff0f53), {
        alt: label || '',
        src: image,
        isDisabled: isDisabled
    });
const $45954f322eeb538a$export$64ef9b8c11710c47 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardcontent),
        ...props
    });
const $45954f322eeb538a$export$43a792a870d28db2 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.loadingwrapper),
        ...props
    });
module.exports["CardWrapper"] = $45954f322eeb538a$export$6aa22a823032b784;
module.exports["CardHeader"] = $45954f322eeb538a$export$5665775b26e26c5d;
module.exports["CardContent"] = $45954f322eeb538a$export$64ef9b8c11710c47;
module.exports["LoadingWrapper"] = $45954f322eeb538a$export$43a792a870d28db2;

});

parcelRegister("lhHcj", function(module, exports) {
/* TeamProfileCardWithTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $fVUfS = parcelRequire("fVUfS");


var $O1c6O = parcelRequire("O1c6O");

var $fDXXi = parcelRequire("fDXXi");


var $dTk3A = parcelRequire("dTk3A");


var $jDp07 = parcelRequire("jDp07");


var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


var $a3dXM = parcelRequire("a3dXM");

const $c35c23abdca41a53$var$fetchPolicy = 'network-only';

const $c35c23abdca41a53$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("1XrtB")), {
        moduleId: "16a28722",
        moduleName: "TeamProfileCardEntryPoint",
        priority: "interaction",
        moduleId: 'team-profile-card-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId, teamId: teamId })=>({
            queries: {
                queryRef: {
                    parameters: $a3dXM.default,
                    variables: {
                        cloudId: cloudId,
                        teamId: teamId
                    },
                    options: {
                        fetchPolicy: $c35c23abdca41a53$var$fetchPolicy
                    }
                }
            }
        })
});









var $irOoi = parcelRequire("irOoi");


var $4rwCt = parcelRequire("4rwCt");


var $lGgRw = parcelRequire("lGgRw");


var $9hlns = parcelRequire("9hlns");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");





var $fFa3V = parcelRequire("fFa3V");




/**
 * Hook for managing delayed hover actions with timeout management.
 *
 * Provides `schedule` and `clear` functions to trigger an action after a delay,
 * useful for implementing hover interactions that should only activate after
 * the user has hovered for a certain duration (e.g., showing a profile card
 * after hovering over a name for 500ms).
 */ function $a1d53adf209f17b2$export$beb151954e0eb9fa(callback, delay) {
    const timeoutRef = (0, $42omo.useRef)(null);
    // Ref pattern keeps `schedule` stable while always calling latest callback
    const callbackRef = (0, $42omo.useRef)(callback);
    (0, $42omo.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const clear = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const schedule = (0, $42omo.useCallback)(()=>{
        clear();
        timeoutRef.current = window.setTimeout(()=>{
            callbackRef.current();
        }, delay);
    }, [
        delay,
        clear
    ]);
    // Cleanup on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>clear();
    }, [
        clear
    ]);
    return {
        schedule: schedule,
        clear: clear
    };
}


/**
 * Type guard to check if an event has a relatedTarget property.
 */ function $648bffbeab2a715a$export$63ce2e5e32c4f6a0(event) {
    return 'relatedTarget' in event;
}
/**
 * Checks if the mouse is moving to an atlaskit portal or kudos modal
 * where we should prevent the popup from closing
 */ function $648bffbeab2a715a$export$386001e6036bddcf(relatedTarget) {
    if (!(relatedTarget instanceof HTMLElement)) return false;
    const iframe = relatedTarget.closest('.atlaskit-portal')?.querySelector('iframe') || relatedTarget.closest('iframe');
    return iframe instanceof HTMLIFrameElement && iframe.src.includes('give-kudos');
}
/**
 * Returns the child portal if mouse is moving to a portal controlled by the parent popup.
 */ function $648bffbeab2a715a$export$a5fb0bbf4bb0e26a(relatedTarget, parentPopupElement) {
    if (!(relatedTarget instanceof HTMLElement) || !parentPopupElement) return null;
    const portal = relatedTarget.closest('.atlaskit-portal');
    if (!portal) return null;
    // Portal controlled by parent popup trigger (e.g. actions menu)
    for (const trigger of parentPopupElement.querySelectorAll('[aria-controls]')){
        const controlsId = trigger.getAttribute('aria-controls');
        if (controlsId && portal.querySelector(`#${controlsId}`)) return portal;
    }
    return null;
}


const $61ccd1f0f9797c9f$var$HOVER_OPEN_DELAY = 800;
const $61ccd1f0f9797c9f$var$HOVER_CLOSE_DELAY = 200;
function $61ccd1f0f9797c9f$export$b8df9ab832b125ac({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef, delays: delays = {} }) {
    const { hoverOpen: hoverOpen = $61ccd1f0f9797c9f$var$HOVER_OPEN_DELAY, hoverClose: hoverClose = $61ccd1f0f9797c9f$var$HOVER_CLOSE_DELAY } = delays;
    const triggerNodeRef = (0, $42omo.useRef)(null);
    const triggerListeners = (0, $42omo.useRef)([]);
    const contentNodeRef = (0, $42omo.useRef)(null);
    const contentListeners = (0, $42omo.useRef)(new Map());
    const isOpenRef = (0, $42omo.useRef)(isOpen);
    (0, $42omo.useLayoutEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    const openDelay = (0, $a1d53adf209f17b2$export$beb151954e0eb9fa)(()=>{
        if (isOpenRef.current) return;
        if (openedByRef) openedByRef.current = 'hover';
        onOpen();
    }, hoverOpen);
    const closeDelay = (0, $a1d53adf209f17b2$export$beb151954e0eb9fa)(()=>{
        if (!isOpenRef.current) return;
        if (!openedByRef || openedByRef.current === 'hover') onClose?.();
    }, hoverClose);
    const openDelayRef = (0, $42omo.useRef)(openDelay);
    const closeDelayRef = (0, $42omo.useRef)(closeDelay);
    openDelayRef.current = openDelay;
    closeDelayRef.current = closeDelay;
    const handleTriggerEnter = (0, $42omo.useCallback)(()=>{
        closeDelayRef.current.clear();
        openDelayRef.current.schedule();
    }, []);
    const handleTriggerLeave = (0, $42omo.useCallback)(()=>{
        openDelayRef.current.clear();
        closeDelayRef.current.schedule();
    }, []);
    const triggerRef = (0, $42omo.useCallback)((element)=>{
        if (element === triggerNodeRef.current) return;
        triggerListeners.current.forEach((unbind)=>unbind());
        triggerListeners.current = [];
        triggerNodeRef.current = element;
        if (element && !isDisabled) triggerListeners.current.push((0, $fFa3V.bind)(element, {
            type: 'mouseenter',
            listener: handleTriggerEnter
        }), (0, $fFa3V.bind)(element, {
            type: 'mouseleave',
            listener: handleTriggerLeave
        }));
    }, [
        handleTriggerEnter,
        handleTriggerLeave,
        isDisabled
    ]);
    const handleContentEnter = (0, $42omo.useCallback)(()=>{
        closeDelayRef.current.clear();
    }, []);
    const cleanupContentListeners = (0, $42omo.useCallback)(()=>{
        contentListeners.current.forEach((unbind)=>unbind());
        contentListeners.current.clear();
    }, []);
    const attachContentListeners = (0, $42omo.useCallback)((element)=>{
        if (contentListeners.current.has(element)) return;
        const handleMouseLeave = (event)=>{
            if (!(0, $648bffbeab2a715a$export$63ce2e5e32c4f6a0)(event)) return;
            const relatedTarget = event.relatedTarget;
            if ((0, $648bffbeab2a715a$export$386001e6036bddcf)(relatedTarget)) return;
            const childPortal = (0, $648bffbeab2a715a$export$a5fb0bbf4bb0e26a)(relatedTarget, contentNodeRef.current);
            if (childPortal) {
                attachContentListeners(childPortal);
                return;
            }
            closeDelayRef.current.schedule();
        };
        const unbindEnter = (0, $fFa3V.bind)(element, {
            type: 'mouseenter',
            listener: handleContentEnter
        });
        const unbindLeave = (0, $fFa3V.bind)(element, {
            type: 'mouseleave',
            listener: handleMouseLeave
        });
        contentListeners.current.set(element, ()=>{
            unbindEnter();
            unbindLeave();
        });
    }, [
        handleContentEnter
    ]);
    const contentRef = (0, $42omo.useCallback)((element)=>{
        if (element === contentNodeRef.current) return;
        cleanupContentListeners();
        contentNodeRef.current = element;
        if (element && !isDisabled) attachContentListeners(element);
    }, [
        attachContentListeners,
        cleanupContentListeners,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        const listeners = contentListeners.current;
        const triggers = triggerListeners.current;
        return ()=>{
            openDelayRef.current.clear();
            closeDelayRef.current.clear();
            triggers.forEach((unbind)=>unbind());
            listeners.forEach((unbind)=>unbind());
        };
    }, []);
    return {
        triggerRef: triggerRef,
        contentRef: contentRef
    };
}








const $002814825f3a3e93$var$PRELOAD_MAX_AGE = 300000;
const $002814825f3a3e93$var$TIME_TO_INTENT = 200;
function $002814825f3a3e93$export$e0cecaf2b8cc8d36({ load: load, onLoad: onLoad }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const { loadAndOpen: loadAndOpen, preloadReference: preloadReference, cancelPreload: cancelPreload } = (0, $42omo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const loadAndOpen = ()=>{
            clearPreloadTimeouts();
            onLoad(loadReference());
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $002814825f3a3e93$var$PRELOAD_MAX_AGE);
            }, $002814825f3a3e93$var$TIME_TO_INTENT);
        };
        return {
            loadAndOpen: loadAndOpen,
            preloadReference: preloadReference,
            cancelPreload: cancelPreload
        };
    }, [
        load,
        onLoad
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
            }
            nodeRef.current = element;
        }
    }, [
        preloadReference,
        cancelPreload,
        addEventListener,
        cleanUpEventListeners
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return Object.assign(refCallback, {
        loadAndOpen: loadAndOpen
    });
}








function $331541a352045086$export$186b93979375b734({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        if (isOpen) onClose?.();
        else {
            if (openedByRef) openedByRef.current = 'click';
            onOpen();
        }
    }, [
        isOpen,
        onClose,
        openedByRef,
        onOpen
    ]);
    const keydownListener = (0, $42omo.useCallback)((event)=>{
        if (event instanceof KeyboardEvent && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleOpen();
        }
    }, [
        handleOpen
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) cleanUpEventListeners();
            if (element) {
                if (!isDisabled) addEventListener(element, 'click', handleOpen);
                // Always attach keydown for keyboard accessibility
                addEventListener(element, 'keydown', keydownListener);
            }
            nodeRef.current = element;
        }
    }, [
        handleOpen,
        keydownListener,
        addEventListener,
        cleanUpEventListeners,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}


const $e5c842f627a67143$var$emptyEntryPointParams = {};
const $e5c842f627a67143$var$emptyEntryPointProps = {};
const $e5c842f627a67143$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: fallback || /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
    });
};
function $e5c842f627a67143$export$afca832e0d04586a({ trigger: trigger, triggerMode: triggerMode = 'hover', entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onOpen: onOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [content, setContent] = (0, $42omo.useState)(null);
    const updateRef = (0, $42omo.useRef)(null);
    const openedByRef = (0, $42omo.useRef)(null);
    const triggers = Array.isArray(triggerMode) ? triggerMode : [
        triggerMode
    ];
    const handleOpen = (0, $42omo.useCallback)((method)=>{
        setIsOpen(true);
        if (method) onOpen?.(method);
    }, [
        onOpen
    ]);
    const handleClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event ?? null, currentLevel);
    }, [
        onClose
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $e5c842f627a67143$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference })=>{
        if (isOpen) return;
        handleOpen(openedByRef.current);
        setContent(/*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $l998X.jsx)($e5c842f627a67143$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $e5c842f627a67143$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const preloadRef = (0, $002814825f3a3e93$export$e0cecaf2b8cc8d36)({
        load: load,
        onLoad: onLoad
    });
    const pressableRef = (0, $331541a352045086$export$186b93979375b734)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('click'),
        openedByRef: openedByRef
    });
    const { triggerRef: hoverTriggerRef, contentRef: hoverContentRef } = (0, $61ccd1f0f9797c9f$export$b8df9ab832b125ac)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('hover'),
        openedByRef: openedByRef
    });
    (0, $42omo.useEffect)(()=>{
        if (!isOpen) openedByRef.current = null;
    }, [
        isOpen
    ]);
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4rwCt.mergeRefs)([
            preloadRef,
            pressableRef,
            hoverTriggerRef,
            triggerProps.ref
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        preloadRef,
        pressableRef,
        hoverTriggerRef
    ]);
    const popupContent = (0, $42omo.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: hoverContentRef,
            role: "none",
            children: content
        });
    }, [
        content,
        hoverContentRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}



var $erW5N = parcelRequire("erW5N");


var $cdYPU = parcelRequire("cdYPU");

/* CardLoading.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");




const $c232fb5899722080$var$styles = {
    wrapper: "_2rko18qm _1reo15vq _18m915vq _1bsb1gwv _kqswh2mm",
    header: "_4t3i12am _1bsb1osq _13li18qm _qrwq18qm",
    content: "_1rjc1ejb _18zr1ejb _1e0c1txw _2lx21bp4 _1tke1w81",
    spinner: "_y3gn1h6o _19pk1jfw _otyr1jfw"
};
/**
 * CardLoading component to display a loading state while team information is being fetched.
 */ function $c232fb5899722080$export$5d25853fd6bdf402() {
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($c232fb5899722080$var$styles.wrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($c232fb5899722080$var$styles.header),
                backgroundColor: "color.background.neutral"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($c232fb5899722080$var$styles.content),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($c232fb5899722080$var$styles.spinner),
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
                })
            })
        ]
    });
}


const $fa7a8541a7e21daa$var$styles = {
    trigger: "_kkk2n7od _1e0c1nu9"
};
/**
 * A wrapper component that displays a team profile card in a popup when a trigger element
 * is interacted with (hover or click).
 *
 * This component loads the team profile card content lazily using an entry point, displays
 * loading and error states, and tracks analytics events for user interactions. The card data
 * is fetched from GraphQL when the popup is triggered.
 */ function $fa7a8541a7e21daa$var$TeamProfileCardWithTrigger({ teamAri: teamAri, cloudId: cloudId, containerId: containerId, userId: userId, showFlag: showFlag, trigger: trigger, placement: placement = 'bottom-start', shouldRenderToParent: shouldRenderToParent = false, children: children, additionalActions: additionalActions }) {
    const fireEvent = (0, $jDp07.useAnalyticsEventsWithDuration)();
    const { fireEvent: fireAnalyticsEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const onErrorBoundary = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.teamProfileCard.rendered.errorBoundary', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $erW5N.getPageTime)())
            }));
    }, [
        fireEvent
    ]);
    const onError = (0, $42omo.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        const { name: errorType, message: errorMessage, ...errorRest } = error;
        fireEvent('operational.teamProfileCard.failed.request', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $erW5N.getPageTime)()),
                gateway: true,
                errorCategory: null,
                errorNumber: null,
                errorPath: null,
                errorStatusCode: null,
                isSLOFailure: true,
                traceId: null,
                errorType: errorType,
                errorMessage: errorMessage,
                errorStack: errorInfo.componentStack ?? null,
                ...errorRest
            }));
        fireEvent('ui.teamProfileCard.rendered.error', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $erW5N.getPageTime)())
            }));
    }, [
        fireEvent
    ]);
    const onOpen = (0, $42omo.useCallback)((method)=>{
        fireAnalyticsEvent('ui.teamProfileCard.triggered', {
            method: method,
            firedAt: Math.round((0, $erW5N.getPageTime)()),
            teamId: teamAri
        });
    }, [
        fireAnalyticsEvent,
        teamAri
    ]);
    if (!teamAri || !cloudId) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        onError: onErrorBoundary,
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: children
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e5c842f627a67143$export$afca832e0d04586a), {
            entryPoint: (0, $c35c23abdca41a53$export$6333901e831d7af0),
            placement: placement,
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $c232fb5899722080$export$5d25853fd6bdf402), {}),
            onError: onError,
            onOpen: onOpen,
            errorFallback: (0, $cdYPU.CardError),
            entryPointParams: {
                cloudId: cloudId,
                teamId: teamAri
            },
            entryPointProps: {
                cloudId: cloudId,
                containerId: containerId,
                userId: userId,
                showFlag: showFlag,
                additionalActions: additionalActions
            },
            shouldRenderToParent: shouldRenderToParent,
            shouldUseCaptureOnOutsideClick: true,
            zIndex: (0, $dTk3A.layers).modal(),
            triggerMode: trigger,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    ...triggerProps,
                    testId: "team-profilecard-trigger-wrapper",
                    xcss: $fa7a8541a7e21daa$var$styles.trigger,
                    children: children
                })
        })
    });
}
const $fa7a8541a7e21daa$export$d5b7952f9e2934c6 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $O1c6O.TeamsAppAnalyticsContext), {
        data: {
            source: 'teamProfileCardTrigger',
            attributes: {
                isRenderedByTrigger: true
            }
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)($fa7a8541a7e21daa$var$TeamProfileCardWithTrigger, {
            ...props
        })
    });
};
module.exports["TeamProfileCardWithTrigger"] = $fa7a8541a7e21daa$export$d5b7952f9e2934c6;

});

parcelRegister("jDp07", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $erW5N = parcelRequire("erW5N");

const $8a4b16041c5e8b91$export$cd1a7849ca36cc69 = ()=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const openTimeRef = (0, $42omo.useRef)((0, $erW5N.getPageTime)());
    const fireAnalyticsWithDuration = (0, $42omo.useCallback)((eventKey, generator)=>{
        const duration = (0, $erW5N.getPageTime)() - openTimeRef.current;
        const attributes = generator(duration);
        fireEvent(eventKey, attributes);
    }, [
        fireEvent
    ]);
    return fireAnalyticsWithDuration;
};
module.exports["useAnalyticsEventsWithDuration"] = $8a4b16041c5e8b91$export$cd1a7849ca36cc69;

});

parcelRegister("erW5N", function(module, exports) {
const $70dc9b90a09621c0$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $70dc9b90a09621c0$var$performanceAvailable = $70dc9b90a09621c0$var$isPerformanceAvailable();
const $70dc9b90a09621c0$var$initialPageTime = Date.now();
const $70dc9b90a09621c0$export$e9faea7c41053334 = ()=>{
    if ($70dc9b90a09621c0$var$performanceAvailable) return performance.now();
    return Date.now() - $70dc9b90a09621c0$var$initialPageTime;
};
module.exports["getPageTime"] = $70dc9b90a09621c0$export$e9faea7c41053334;

});

parcelRegister("a3dXM", function(module, exports) {
/**
 * @generated SignedSource<<b6056e1391ea3fb72ac82076450b4e60>>
 * @relayHash 2cfa96b41e6e3842d1b36c5518845b0b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 987e50ade6523a584a993826a7fd5c7d9c366fe4e6ff1c5b644e9ea5f590584e
const $19992bee6b86d774$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "teamId"
        },
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TeamProfileCardEntryPointQuery",
            "selections": [
                {
                    "concreteType": "TeamQuery",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "teamV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "TeamProfileCardRelay_AtlassianTeamProfilecard"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TeamProfileCardEntryPointQuery",
            "selections": [
                {
                    "concreteType": "TeamQuery",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "teamV2",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "smallHeaderImageUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "smallAvatarImageUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isVerified"
                                },
                                {
                                    "concreteType": "TeamMemberConnectionV2",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TeamMemberV2",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "member",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "987e50ade6523a584a993826a7fd5c7d9c366fe4e6ff1c5b644e9ea5f590584e",
            "metadata": {},
            "name": "TeamProfileCardEntryPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$19992bee6b86d774$var$node.hash = "c9412d7c2df6f5eec001d802dbedc65d";
var $19992bee6b86d774$export$2e2bcd8739ae039 = $19992bee6b86d774$var$node;
module.exports["default"] = $19992bee6b86d774$export$2e2bcd8739ae039;

});

parcelRegister("1XrtB", function(module, exports) {

let $16d09d6650bd2355$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16d09d6650bd2355$var$load("eY3St"),
    $16d09d6650bd2355$var$load("bkd4T"),
    $16d09d6650bd2355$var$load("6wr18"),
    $16d09d6650bd2355$var$load("64UoX"),
    $16d09d6650bd2355$var$load("bMldg"),
    $16d09d6650bd2355$var$load("4ketu"),
    $16d09d6650bd2355$var$load("hyzoX"),
    $16d09d6650bd2355$var$load("hhss7"),
    $16d09d6650bd2355$var$load("ffEVr"),
    $16d09d6650bd2355$var$load("7BRMY")
]).then(()=>parcelRequire('1BzrK'));

});

parcelRegister("cdYPU", function(module, exports) {
/* CardError.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");




parcelRequire("42omo");

const $c3d350a1ca343994$export$e0319f52fc2380b1 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "42",
        height: "53",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0.649902 0H163.93V212H0.649902V0Z",
                        fill: "var(--ds-surface-overlay, white)",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
                        fill: "url(#paint0_linear)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                        opacity: "0.6",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                opacity: "0.6",
                                d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
                                fill: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                opacity: "0.6",
                                d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
                                fill: "#C1C7D0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("g", {
                            opacity: "0.6",
                            children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                opacity: "0.6",
                                d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
                                fill: "#B3BAC5"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.6",
                            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
                            fill: "#B3BAC5"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.6",
                            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
                            fill: "#B3BAC5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "26.1692",
                        y1: "228.621",
                        x2: "138.408",
                        y2: "116.382",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.297",
                                stopColor: "#C6CBD4",
                                stopOpacity: "0.8812"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6301",
                                stopColor: "#D3D7DE",
                                stopOpacity: "0.748"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9795",
                                stopColor: "#E9EBEF",
                                stopOpacity: "0.6082"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0",
                                stopOpacity: "0.6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M0.649902 0H163.93V212H0.649902V0Z",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};


const $92d0b6a61722d9c7$var$styles = {
    wrapper: "_2rko18qm _y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1bsb1gwv",
    text: "_syaz1rpy _19pku2gc"
};
/**
 * CardError component to display an error message when team information cannot be retrieved.
 */ function $92d0b6a61722d9c7$export$f7f7efdefcc02999() {
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($92d0b6a61722d9c7$var$styles.wrapper),
        testId: "team-profilecard-error",
        backgroundColor: "elevation.surface.overlay",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c3d350a1ca343994$export$e0319f52fc2380b1), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                weight: "semibold",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$92d0b6a61722d9c7$var$messages.title
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $92d0b6a61722d9c7$var$styles.text,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$92d0b6a61722d9c7$var$messages.text
                })
            })
        ]
    });
}
const $92d0b6a61722d9c7$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    text: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    }
});
module.exports["CardError"] = $92d0b6a61722d9c7$export$f7f7efdefcc02999;

});


//# sourceMappingURL=ProjectPanel.b8e29b4d.js.map
